module.exports = __webpack_public_path__ + "img/etoro.1dae49d0.svg";